<template>
    <div ref="filter-option-element">
        <!-- Display selected options -->
        <div v-for="(tag, index) in getPrettySelectedOption" :key="tag"
             class="table-browser-dropdown-selected-options" :style="customWidth"
        >
          <span @click="removeSelectedOption(index)">x </span>
            {{ tag }}
        </div>

        <!-- Search for options -->
        <div>
            <!-- Need to prevent enter key from submitting the bulk action form-->
            <input v-model="metadataTypeSearch" type="text" placeholder="Select options to filter"
                   class="form-control" @click="isDropped=true" @keypress.13.prevent
                   ref="search-bar"
            >
        </div>

        <!-- List of options -->
        <div>
            <transition name="table-browser-slide">
                <ul class="table-browser-dropdown-menu table-browser-fixed-dimension" v-if="isDropped">
                    <li v-show="isVisibleMetadataType(value[1])"
                        v-for="(value, state, index) in options" :key="index" :value="value[0]"
                    >
                        <!-- Need to prevent enter key from submitting the bulk action form-->
                        <input
                            type="checkbox"
                            id="optionIndex"
                            :value="value[0]"
                            v-model="mutableMultipleSelectedOptions"
                            @change="applyChanges"
                            @keypress.13.prevent
                        >
                        <label for="optionIndex" class="table-browser-dropdown-option-margin-left">
                            {{ value[1] }}
                        </label>
                        &nbsp;
                        <i v-if="value[2]" :class="value[2]" title="In progress" />
                    </li>
                </ul>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterOption",
    props: {
        options: {
            type: Array,
            required: true,
        },

        totalVisibleTableColumns: {
            type: Number,
            required: true,
        },

        initialMultipleSelectedOption: {
            type: String,
            required: true,
        }
    },

    data: () => ({
        mutableMultipleSelectedOptions: [],
        mutableMultipleSelectedOptionsToEmit: [],
        isDropped: false,
        metadataTypeSearch: '',
        customWidth: {width: "auto"},
    }),

    computed: {
        getPrettySelectedOption() {
            let prettySelectedOption = []
            for (let j = 0; j < this.mutableMultipleSelectedOptions.length; j++) {
                for (let i = 0; i < this.options.length; i++) {
                    if (this.mutableMultipleSelectedOptions[j] === this.options[i][0]) {
                        prettySelectedOption.push(this.options[i][1])
                    }
                }
            }
            return prettySelectedOption
        }
    },

    watch: {
        totalVisibleTableColumns: function () {
            this.setTagWidth()
        }
    },

    mounted() {
        this.setInitialMultipleSelectedOption()
        this.setTagWidth()
        document.addEventListener('click', this.closeDropdown)
    },

    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdown)
    },

    methods: {
        // Help to search for options
        isVisibleMetadataType: function (metadataType) {
            let currentType = metadataType.toLowerCase()
            let currentInput = this.metadataTypeSearch.toLowerCase()
            return currentType.includes(currentInput)
        },

        setInitialMultipleSelectedOption: function () {
            this.initialMultipleSelectedOption ?
                this.mutableMultipleSelectedOptions = this.initialMultipleSelectedOption.split(",") :
                this.mutableMultipleSelectedOptions = []
        },

        applyChanges: function () {
            this.$emit('update-selected-option', {
                'multipleSelectedOption': this.mutableMultipleSelectedOptions
            })
        },

        // Used to close dropdown when click outside of the dropdown menu
        closeDropdown(event) {
            if (!this.$el.contains(event.target)) {
                this.isDropped = false
            }
        },

        removeSelectedOption(index) {
            this.mutableMultipleSelectedOptions.splice(index, 1)
            this.applyChanges()
        },

        // Need fixed width for "text-overflow: ellipsis" to work
        setTagWidth: function () {
            if (this.totalVisibleTableColumns >= 6) {
                this.customWidth.width = this.$refs["filter-option-element"].clientWidth + 'px'
            } else {
                this.customWidth.width = "auto"
            }
        }
    }
}
</script>
